<template>
	<div
		class="min-h-screen flex items-center justify-center bg-[#f0f7f5] p-6 font-['Montserrat',sans-serif]">
		<form
			@submit.prevent="submitForm"
			class="flex w-full md:max-w-[860px] min-h-[580px] rounded-2xl overflow-hidden border border-[#d0ede8] shadow-[0_8px_40px_rgba(15,31,28,0.10)]">
			<!-- ── LEFT PANEL ── -->
			<div
				class="flex-1 bg-[#f0f7f5] flex flex-col p-6 md:p-10 relative overflow-hidden">
				<!-- Imigongo background patterns -->
				<!-- Top-left: diamond grid -->
				<svg
					class="absolute -top-6 -left-6 w-44 h-44 opacity-[0.08] pointer-events-none"
					viewBox="0 0 160 160"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g fill="#0d6b5e">
						<rect
							x="40"
							y="0"
							width="28"
							height="28"
							transform="rotate(45 40 0)" />
						<rect
							x="80"
							y="0"
							width="28"
							height="28"
							transform="rotate(45 80 0)" />
						<rect
							x="120"
							y="0"
							width="28"
							height="28"
							transform="rotate(45 120 0)" />
						<rect
							x="20"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 20 40)" />
						<rect
							x="60"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 60 40)" />
						<rect
							x="100"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 100 40)" />
						<rect
							x="140"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 140 40)" />
						<rect
							x="40"
							y="80"
							width="28"
							height="28"
							transform="rotate(45 40 80)" />
						<rect
							x="80"
							y="80"
							width="28"
							height="28"
							transform="rotate(45 80 80)" />
						<rect
							x="120"
							y="80"
							width="28"
							height="28"
							transform="rotate(45 120 80)" />
						<rect
							x="20"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 20 120)" />
						<rect
							x="60"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 60 120)" />
						<rect
							x="100"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 100 120)" />
						<rect
							x="140"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 140 120)" />
					</g>
				</svg>

				<!-- Bottom-right: stacked triangles (Imigongo mountain motif) -->
				<svg
					class="absolute -bottom-4 -right-4 w-48 h-48 opacity-[0.08] pointer-events-none"
					viewBox="0 0 160 160"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g fill="#0d6b5e">
						<rect
							x="40"
							y="0"
							width="28"
							height="28"
							transform="rotate(45 40 0)" />
						<rect
							x="80"
							y="0"
							width="28"
							height="28"
							transform="rotate(45 80 0)" />
						<rect
							x="120"
							y="0"
							width="28"
							height="28"
							transform="rotate(45 120 0)" />
						<rect
							x="20"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 20 40)" />
						<rect
							x="60"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 60 40)" />
						<rect
							x="100"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 100 40)" />
						<rect
							x="140"
							y="40"
							width="28"
							height="28"
							transform="rotate(45 140 40)" />
						<rect
							x="40"
							y="80"
							width="28"
							height="28"
							transform="rotate(45 40 80)" />
						<rect
							x="80"
							y="80"
							width="28"
							height="28"
							transform="rotate(45 80 80)" />
						<rect
							x="120"
							y="80"
							width="28"
							height="28"
							transform="rotate(45 120 80)" />
						<rect
							x="20"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 20 120)" />
						<rect
							x="60"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 60 120)" />
						<rect
							x="100"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 100 120)" />
						<rect
							x="140"
							y="120"
							width="20"
							height="20"
							transform="rotate(45 140 120)" />
					</g>
				</svg>

				<!-- Middle-left: nested diamond (Imigongo interlocking squares) -->
				<svg
					class="absolute top-1/2 -left-10 -translate-y-1/2 w-32 h-32 opacity-[0.05] pointer-events-none"
					viewBox="0 0 120 120"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g stroke="#0d6b5e" stroke-width="3" fill="none">
						<rect
							x="60"
							y="10"
							width="64"
							height="64"
							transform="rotate(45 60 10)" />
						<rect
							x="60"
							y="22"
							width="46"
							height="46"
							transform="rotate(45 60 22)" />
						<rect
							x="60"
							y="34"
							width="28"
							height="28"
							transform="rotate(45 60 34)" />
						<rect
							x="60"
							y="46"
							width="10"
							height="10"
							transform="rotate(45 60 46)" />
					</g>
				</svg>

				<!-- Top-right: chevron/zigzag strip -->
				<svg
					class="absolute top-24 -right-2 w-16 h-48 opacity-[0.05] pointer-events-none"
					viewBox="0 0 60 180"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g fill="#0d6b5e">
						<polygon points="0,0 60,0 30,30" />
						<polygon points="0,40 60,40 30,70" />
						<polygon points="0,80 60,80 30,110" />
						<polygon points="0,120 60,120 30,150" />
					</g>
				</svg>

				<!-- Bottom-left: small diamond row -->
				<svg
					class="absolute bottom-16 left-6 w-36 h-10 opacity-[0.08] pointer-events-none"
					viewBox="0 0 140 36"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g fill="#0d6b5e">
						<rect
							x="18"
							y="18"
							width="22"
							height="22"
							transform="rotate(45 18 18)" />
						<rect
							x="52"
							y="18"
							width="22"
							height="22"
							transform="rotate(45 52 18)" />
						<rect
							x="86"
							y="18"
							width="22"
							height="22"
							transform="rotate(45 86 18)" />
						<rect
							x="120"
							y="18"
							width="22"
							height="22"
							transform="rotate(45 120 18)" />
					</g>
				</svg>

				<!-- Logo + back to home -->
				<div class="flex items-center justify-between mb-9">
					<div
						class="flex items-center gap-2 font-['mons',sans-serif] font-extrabold text-xl text-[#0d6b5e]">
						<span
							class="w-2.5 h-2.5 rounded-full bg-[#1a9b8a] animate-pulse inline-block" />
						Trekko
					</div>
					<a
						href="/"
						class="flex items-center gap-1.5 text-[12px] font-semibold text-[#6b8f89] hover:text-[#1a9b8a] transition-colors no-underline">
						<i class="ti ti-arrow-left text-[14px]" aria-hidden="true" />
						Back to home
					</a>
				</div>

				<div class="flex-1 flex flex-col justify-center">
					<!-- Dynamic heading -->
					<div class="mb-6">
						<h1
							class="font-['Montserrat',sans-serif] font-extrabold text-[28px] text-[#0f1f1c] leading-tight mb-1.5">
							<template v-if="isRegistering">Join Trekko</template>
							<template v-else-if="isOTPRequested">Check your inbox</template>
							<template v-else>Welcome Back!</template>
						</h1>
						<p class="text-[13px] text-[#6b8f89]">
							<template v-if="isRegistering"
								>Create your organizer account below</template
							>
							<template v-else-if="isOTPRequested"
								>Enter the 6-digit code we sent to your email</template
							>
							<template v-else>Please enter your login details below</template>
						</p>
					</div>

					<!-- Messages -->
					<div
						v-if="successMessage"
						class="flex items-center gap-2 text-[12px] font-medium px-3.5 py-2.5 rounded-xl mb-3.5 bg-[#e6f4f0] text-[#0d6b5e] border border-[#a8d5cc]">
						<i class="ti ti-circle-check text-[15px]" aria-hidden="true" />{{
							successMessage
						}}
					</div>
					<div
						v-if="errorMessage"
						class="flex items-center gap-2 text-[12px] font-medium px-3.5 py-2.5 rounded-xl mb-3.5 bg-red-50 text-red-700 border border-red-200">
						<i class="ti ti-alert-circle text-[15px]" aria-hidden="true" />{{
							errorMessage
						}}
					</div>
					<div
						v-if="infoMessage"
						class="flex items-center gap-2 text-[12px] font-medium px-3.5 py-2.5 rounded-xl mb-3.5 bg-blue-50 text-blue-700 border border-blue-200">
						<i class="ti ti-info-circle text-[15px]" aria-hidden="true" />{{
							infoMessage
						}}
					</div>
					<div
						v-if="warningMessage"
						class="flex items-center gap-2 text-[12px] font-medium px-3.5 py-2.5 rounded-xl mb-3.5 bg-orange-50 text-orange-700 border border-orange-200">
						<i class="ti ti-alert-triangle text-[15px]" aria-hidden="true" />{{
							warningMessage
						}}
					</div>

					<!-- ── REGISTER ── -->
					<div v-if="isRegistering" class="flex flex-col gap-3">
						<div class="relative">
							<i
								class="ti ti-user absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a8c5c0] text-base pointer-events-none"
								aria-hidden="true" />
							<input
								v-model="user.name"
								type="text"
								placeholder="User Name"
								class="w-full bg-white text-[#0f1f1c] placeholder-[#b0ccc8] text-[13px] pl-10 pr-4 py-3.5 rounded-xl border-[1.5px] border-[#d0ede8] outline-none transition-all focus:border-[#1a9b8a] focus:ring-2 focus:ring-[#1a9b8a]/20" />
						</div>
						<div class="relative">
							<i
								class="ti ti-mail absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a8c5c0] text-base pointer-events-none"
								aria-hidden="true" />
							<input
								v-model="user.email"
								type="email"
								placeholder="Email Address"
								class="w-full bg-white text-[#0f1f1c] placeholder-[#b0ccc8] text-[13px] pl-10 pr-4 py-3.5 rounded-xl border-[1.5px] border-[#d0ede8] outline-none transition-all focus:border-[#1a9b8a] focus:ring-2 focus:ring-[#1a9b8a]/20" />
						</div>
						<div class="relative">
							<i
								class="ti ti-building-store absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a8c5c0] text-base pointer-events-none"
								aria-hidden="true" />
							<input
								v-model="user.promoter"
								type="text"
								placeholder="Company, Agency or Promoter Name"
								class="w-full bg-white text-[#0f1f1c] placeholder-[#b0ccc8] text-[13px] pl-10 pr-4 py-3.5 rounded-xl border-[1.5px] border-[#d0ede8] outline-none transition-all focus:border-[#1a9b8a] focus:ring-2 focus:ring-[#1a9b8a]/20" />
						</div>
						<button
							type="submit"
							:disabled="isSubmitting"
							class="w-full py-3.5 bg-[#0f1f1c] text-white font-['Montserrat',sans-serif] font-bold text-[13px] rounded-xl transition-all hover:bg-[#1a9b8a] hover:-translate-y-0.5 border-none cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2">
							<svg
									v-if="isSubmitting"
									class="animate-spin h-[15px] w-[15px]"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<circle
										class="opacity-25"
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="4" />
									<path
										class="opacity-75"
										fill="currentColor"
										d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
								</svg>
							{{ isSubmitting ? "Registering…" : "Register" }}
						</button>
					</div>

					<!-- ── LOGIN ── -->
					<div v-else class="flex flex-col gap-3">
						<!-- Step 1: email -->
						<template v-if="!isOTPRequested">
							<div class="relative">
								<i
									class="ti ti-mail absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a8c5c0] text-base pointer-events-none"
									aria-hidden="true" />
								<input
									v-model="user.email"
									type="email"
									placeholder="Email Address"
									class="w-full bg-white text-[#0f1f1c] placeholder-[#b0ccc8] text-[13px] pl-10 pr-4 py-3.5 rounded-xl border-[1.5px] border-[#d0ede8] outline-none transition-all focus:border-[#1a9b8a] focus:ring-2 focus:ring-[#1a9b8a]/20" />
							</div>
							<button
								type="submit"
								:disabled="isSubmitting"
								class="w-full py-3.5 bg-[#0f1f1c] text-white font-['Montserrat',sans-serif] font-bold text-[13px] rounded-xl transition-all hover:bg-[#1a9b8a] hover:-translate-y-0.5 border-none cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2">
								<svg
									v-if="isSubmitting"
									class="animate-spin h-[15px] w-[15px]"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<circle
										class="opacity-25"
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="4" />
									<path
										class="opacity-75"
										fill="currentColor"
										d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
								</svg>
								{{ isSubmitting ? "Checking…" : "Continue with Email" }}
							</button>
						</template>

						<!-- Step 2: OTP -->
						<template v-else>
							<div class="relative">
								<i
									class="ti ti-lock absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a8c5c0] text-base pointer-events-none"
									aria-hidden="true" />
								<input
									v-model="user.otp"
									type="text"
									placeholder="— — — — — —"
									:disabled="isSubmitting"
									maxlength="6"
									class="w-full bg-white text-[#0f1f1c] placeholder-[#b0ccc8] text-lg font-bold tracking-[.35em] text-center pl-10 pr-4 py-3.5 rounded-xl border-[1.5px] border-[#d0ede8] outline-none transition-all focus:border-[#1a9b8a] focus:ring-2 focus:ring-[#1a9b8a]/20 disabled:bg-gray-50 disabled:cursor-not-allowed" />
							</div>
							<button
								type="submit"
								:disabled="user.otp.length !== 6 || isSubmitting"
								class="w-full py-3.5 bg-[#0f1f1c] text-white font-['Montserrat',sans-serif] font-bold text-[13px] rounded-xl transition-all hover:bg-[#1a9b8a] hover:-translate-y-0.5 border-none cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
								:class="
									user.otp.length !== 6 || isSubmitting
										? 'bg-[#d0ede8] text-[#8ab5ae] cursor-not-allowed'
										: 'bg-[#0f1f1c] text-white hover:bg-[#1a9b8a] hover:-translate-y-0.5'
								">
								<svg
									v-if="isSubmitting"
									class="animate-spin h-[15px] w-[15px]"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<circle
										class="opacity-25"
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="4" />
									<path
										class="opacity-75"
										fill="currentColor"
										d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
								</svg>
								{{ isSubmitting ? "Verifying…" : "Submit OTP" }}
							</button>

							<!-- Step A: countdown running — show timer, hide resend -->
							<div
								v-if="countdown > 0"
								class="flex items-center justify-center gap-3 py-2.5 px-4 rounded-xl bg-[#e6f4f0] border border-[#d0ede8]">
								<div class="relative w-9 h-9 flex-shrink-0">
									<svg class="w-9 h-9 -rotate-90" viewBox="0 0 36 36">
										<circle
											cx="18"
											cy="18"
											r="14"
											fill="none"
											stroke="#d0ede8"
											stroke-width="2.5" />
										<circle
											cx="18"
											cy="18"
											r="14"
											fill="none"
											stroke="#1a9b8a"
											stroke-width="2.5"
											stroke-dasharray="87.96"
											:stroke-dashoffset="87.96 - (87.96 * countdown) / 60"
											stroke-linecap="round" />
									</svg>
									<span
										class="absolute inset-0 flex items-center justify-center text-[10px] font-bold text-[#1a9b8a]"
										>{{ countdown }}</span
									>
								</div>
								<div>
									<p class="text-[12px] font-semibold text-[#0d6b5e]">
										Code sent to your email
									</p>
									<p class="text-[11px] text-[#6b8f89]">
										Resend available in
										<strong class="text-[#0d6b5e]">{{ countdown }}s</strong>
									</p>
								</div>
							</div>

							<!-- Step B: countdown done — show resend option -->
							<div v-else class="pt-3.5 border-t border-[#d0ede8] mt-1">
								<div
									v-if="resendAttempts < maxResendAttempts"
									class="flex items-center justify-between">
									<span class="text-[12px] text-[#6b8f89]"
										>Didn't receive the code?</span
									>
									<button
										type="button"
										@click="resendOTP"
										:disabled="isResending"
										class="text-[12px] font-bold font-['Montserrat',sans-serif] text-[#1a9b8a] hover:text-[#0d6b5e] transition-colors bg-transparent border-none cursor-pointer">
										{{ isResending ? "Sending…" : "Resend OTP" }}
									</button>
								</div>

								<!-- Rate limit reached -->
								<div
									v-else
									class="flex items-center gap-2 text-[12px] font-medium px-3.5 py-2.5 rounded-xl bg-orange-50 text-orange-700 border border-orange-200">
									<i
										class="ti ti-alert-triangle text-[15px]"
										aria-hidden="true" />
									Too many OTP requests. Please try again later.
								</div>
							</div>
						</template>
					</div>

					<!-- Toggle -->
					<div class="text-center mt-5">
						<button
							type="button"
							@click.prevent="isRegistering = !isRegistering"
							class="text-[12px] text-[#1a9b8a] font-semibold underline underline-offset-2 hover:text-[#0d6b5e] transition-colors bg-transparent border-none cursor-pointer font-['Montserrat',sans-serif]">
							{{
								isRegistering
									? "Already have an account? Login"
									: "Don't have an account? Register!"
							}}
						</button>
					</div>
				</div>
			</div>

			<!-- ── RIGHT PANEL — desktop only ── -->
			<div
				class="hidden md:flex w-[46%] bg-[#0f1f1c] relative overflow-hidden flex-col items-center justify-end p-8">
				<!-- Blobs -->
				<div
					class="absolute w-[280px] h-[260px] bg-[#1a9b8a] opacity-[.12] pointer-events-none rounded-[62%_38%_46%_54%/60%_44%_56%_40%] -top-20 -right-14" />
				<div
					class="absolute w-[180px] h-[180px] bg-[#f0e040] opacity-[.07] pointer-events-none rounded-[50%_60%_40%_50%/50%_40%_60%_50%] bottom-28 -left-10" />

				<!-- SLIDE 1 -->
				<div
					class="absolute inset-0 flex flex-col items-center justify-end p-8 transition-opacity duration-500"
					:class="
						currentSlide === 0
							? 'opacity-100 pointer-events-auto'
							: 'opacity-0 pointer-events-none'
					">
					<div class="absolute top-9 -right-1 z-10">
						<div
							class="bg-white/[.07] border border-white/[.12] rounded-2xl p-2.5 mb-2 w-[155px]">
							<div class="flex items-center gap-2 mb-1.5">
								<div
									class="w-7 h-7 rounded-lg bg-[#1a9b8a] font-['Montserrat',sans-serif] font-extrabold text-[10px] text-white flex items-center justify-center flex-shrink-0">
									SO
								</div>
								<div>
									<div class="text-[11px] font-semibold text-white">
										Sound On Events
									</div>
									<div class="text-[9px] text-white/45">Rome, Italy</div>
								</div>
								<span
									class="ml-auto text-[9px] font-bold bg-[#1a9b8a]/30 text-[#a8d5cc] rounded-full px-2 py-0.5 whitespace-nowrap"
									>Live</span
								>
							</div>
							<div class="h-1 bg-white/10 rounded-full overflow-hidden">
								<div class="h-full w-[72%] bg-[#1a9b8a] rounded-full" />
							</div>
						</div>
						<div
							class="bg-white/[.07] border border-white/[.12] rounded-2xl p-2.5 w-[120px] ml-auto">
							<div
								class="font-['Montserrat',sans-serif] font-extrabold text-[22px] text-[#1a9b8a] leading-none">
								4.8
							</div>
							<div class="text-[9px] text-white/45 mt-1">★ Avg Rating</div>
						</div>
					</div>
					<div class="relative z-10 w-[190px] h-[190px] mb-4 flex-shrink-0">
						<svg
							viewBox="0 0 220 220"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							class="w-full h-full">
							<polygon
								points="110,10 200,58 200,162 110,210 20,162 20,58"
								fill="rgba(26,155,138,0.12)"
								stroke="#1a9b8a"
								stroke-width="1.5"
								stroke-opacity="0.4" />
							<text
								x="110"
								y="95"
								text-anchor="middle"
								font-family="Montserrat,sans-serif"
								font-size="46"
								font-weight="800"
								fill="#1a9b8a"
								opacity="0.9">
								Tr
							</text>
							<text
								x="110"
								y="145"
								text-anchor="middle"
								font-family="Montserrat,sans-serif"
								font-size="12"
								font-weight="600"
								fill="rgba(255,255,255,0.4)">
								Trekko Platform
							</text>
							<circle cx="54" cy="60" r="8" fill="#f0e040" opacity="0.6" />
							<polygon
								points="168,170 176,185 160,185"
								fill="#1a9b8a"
								opacity="0.7" />
						</svg>
					</div>
					<div class="flex gap-2 mb-4 relative z-10">
						<div
							v-for="s in slideOneStats"
							:key="s.lbl"
							class="bg-white/[.06] border border-white/10 rounded-xl px-3 py-2 text-center">
							<div
								class="font-['Montserrat',sans-serif] font-extrabold text-[#1a9b8a] leading-none"
								:class="s.sm ? 'text-[13px]' : 'text-[18px]'">
								{{ s.num }}
							</div>
							<div class="text-[9px] text-white/40 mt-1">{{ s.lbl }}</div>
						</div>
					</div>
					<div class="relative z-10 text-center w-full mb-1">
						<h2
							class="font-['Montserrat',sans-serif] font-extrabold text-[19px] text-white leading-snug mb-2">
							Manage Your Events<br />Anywhere
						</h2>
						<p
							class="text-[12px] text-white/45 leading-relaxed max-w-[220px] mx-auto mb-4">
							Your complete event hub — ticketing, analytics, and audience in
							one place.
						</p>
					</div>
				</div>

				<!-- SLIDE 2 -->
				<div
					class="absolute inset-0 flex flex-col items-center justify-end p-8 transition-opacity duration-500"
					:class="
						currentSlide === 1
							? 'opacity-100 pointer-events-auto'
							: 'opacity-0 pointer-events-none'
					">
					<div
						class="relative z-10 bg-[#111c1a] border border-white/10 rounded-2xl overflow-hidden w-[210px] mb-5">
						<div
							class="bg-white/[.06] px-3 py-2 flex items-center gap-1.5 border-b border-white/[.07]">
							<span
								class="w-[7px] h-[7px] rounded-full bg-[#ff5f57] inline-block" />
							<span
								class="w-[7px] h-[7px] rounded-full bg-[#febc2e] inline-block" />
							<span
								class="w-[7px] h-[7px] rounded-full bg-[#28c840] inline-block" />
							<div
								class="flex-1 ml-1.5 bg-white/[.07] rounded px-2 py-0.5 text-[9px] text-white/40">
								soundon.trekko.xyz
							</div>
						</div>
						<div class="p-3">
							<div class="flex items-center gap-2 mb-2.5">
								<div
									class="w-8 h-8 rounded-lg bg-[#1a9b8a] font-['Montserrat',sans-serif] font-extrabold text-[11px] text-white flex items-center justify-center flex-shrink-0">
									SO
								</div>
								<div>
									<div class="text-[11px] font-semibold text-white">
										Sound On Events
									</div>
									<div class="text-[9px] text-white/35 mt-0.5">
										📍 Rome, Italy
									</div>
								</div>
							</div>
							<div
								class="text-[8px] font-bold text-white/30 tracking-widest mb-1.5">
								UPCOMING EVENTS
							</div>
							<div
								v-for="e in mockEvents"
								:key="e.name"
								class="flex items-center justify-between py-1.5 border-b border-white/[.05] last:border-none">
								<div>
									<div class="text-[10px] text-white font-medium">
										{{ e.name }}
									</div>
									<div class="text-[8px] text-white/35 mt-0.5">
										{{ e.date }}
									</div>
								</div>
								<span
									class="text-[9px] font-bold bg-[#1a9b8a]/30 text-[#a8d5cc] rounded-full px-2 py-0.5"
									>{{ e.label }}</span
								>
							</div>
						</div>
					</div>
					<div class="relative z-10 text-center w-full mb-1">
						<h2
							class="font-['Montserrat',sans-serif] font-extrabold text-[19px] text-white leading-snug mb-2">
							Your Own Page<br />on the Web
						</h2>
						<p
							class="text-[12px] text-white/45 leading-relaxed max-w-[220px] mx-auto mb-4">
							Every organizer gets a personal hub at yourname.trekko.xyz —
							shareable in one link.
						</p>
					</div>
				</div>

				<!-- SLIDE 3 -->
				<div
					class="absolute inset-0 flex flex-col items-center justify-end p-8 transition-opacity duration-500"
					:class="
						currentSlide === 2
							? 'opacity-100 pointer-events-auto'
							: 'opacity-0 pointer-events-none'
					">
					<div
						class="relative z-10 bg-white/[.06] border border-white/10 rounded-2xl p-4 w-[210px] mb-5">
						<div
							class="text-[9px] font-bold text-white/35 tracking-widest mb-2.5">
							TICKET SALES VELOCITY
						</div>
						<div class="flex items-end gap-1.5 h-[60px] mb-2">
							<div
								v-for="(bar, i) in chartBars"
								:key="i"
								class="flex-1 rounded-t"
								:class="bar.hi ? 'bg-[#1a9b8a]' : 'bg-white/[.15]'"
								:style="{ height: bar.h }" />
						</div>
						<div class="flex justify-between text-[8px] text-white/30">
							<span
								v-for="d in ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']"
								:key="d"
								>{{ d }}</span
							>
						</div>
						<div class="flex items-center justify-between mt-3">
							<div>
								<div
									class="font-['Montserrat',sans-serif] font-extrabold text-[22px] text-[#1a9b8a] leading-none">
									150+
								</div>
								<div class="text-[9px] text-white/40 mt-1">Users this week</div>
							</div>
							<div
								class="text-[11px] font-bold text-[#1a9b8a] bg-[#1a9b8a]/15 rounded-lg px-2.5 py-1">
								↑ 24%
							</div>
						</div>
					</div>
					<div class="relative z-10 text-center w-full mb-1">
						<h2
							class="font-['Montserrat',sans-serif] font-extrabold text-[19px] text-white leading-snug mb-2">
							Real-Time Analytics<br />at a Glance
						</h2>
						<p
							class="text-[12px] text-white/45 leading-relaxed max-w-[220px] mx-auto mb-4">
							Track sales, revenue, and attendee trends live from your
							dashboard.
						</p>
					</div>
				</div>

				<!-- Dots -->
				<div class="relative z-10 flex gap-1.5">
					<div
						v-for="i in 3"
						:key="i"
						class="h-[7px] rounded-full cursor-pointer transition-all duration-300"
						:class="
							currentSlide === i - 1
								? 'w-5 bg-[#1a9b8a]'
								: 'w-[7px] bg-white/20'
						"
						@click="goSlide(i - 1)" />
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { reactive, ref, onMounted, onBeforeUnmount, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { apiDataService } from "@/services/apiDataService";

export default {
	name: "LoginRegisterPage",
	setup() {
		// ── login/register logic ───────────────────────────────
		const user = reactive({
			name: "",
			email: "",
			promoter: "",
			otp: "",
			user_type: 2,
		});
		const isSubmitting = ref(false);
		const isResending = ref(false);
		const countdown = ref(0);
		const resendAttempts = ref(0);
		const successMessage = ref("");
		const errorMessage = ref("");
		const infoMessage = ref("");
		const warningMessage = ref("");
		const COUNTDOWN_DURATION = 60;
		const maxResendAttempts = 3;
		const savedEmail = ref("");
		const isOTPRequested = ref(false);
		const isRegistering = ref(false);
		const messageTimeout = ref(null);
		const route = useRoute();
		const router = useRouter();
		const redirectUrl = ref("/admin/dashboard");
		const canResend = computed(
			() => countdown.value === 0 && resendAttempts.value < maxResendAttempts,
		);

		const startCountdown = () => {
			countdown.value = COUNTDOWN_DURATION;
			const timer = setInterval(() => {
				countdown.value--;
				if (countdown.value <= 0) clearInterval(timer);
			}, 1000);
		};

		const setMessage = (type, text, duration = 5000) => {
			clearTimeout(messageTimeout.value);
			successMessage.value =
				errorMessage.value =
				infoMessage.value =
				warningMessage.value =
					"";
			if (type === "success") successMessage.value = text;
			else if (type === "info") infoMessage.value = text;
			else if (type === "warning") warningMessage.value = text;
			else errorMessage.value = text;
			messageTimeout.value = setTimeout(() => {
				successMessage.value =
					errorMessage.value =
					infoMessage.value =
					warningMessage.value =
						"";
			}, duration);
		};

		const submitForm = async () => {
			if (isRegistering.value) {
				isSubmitting.value = true;   
				const formData = new FormData();
				formData.append("name", user.promoter);
				formData.append("email", user.email);
				formData.append("phone", "");
				formData.append("description", "");
				formData.append("logo", "");
				try {
					const response = await apiDataService.createOrganization(formData);
					if (response.code === 201) {
						isRegistering.value = false;
						savedEmail.value = user.email;
						setMessage("success", "Registration successful! Please login!");
					}
				} catch {
					setMessage("error", "Registration failed. Please try again!");
				} finally {
					isSubmitting.value = false;
				}
			} else {
				if (!isOTPRequested.value) {
					isSubmitting.value = true; 
					const responseCheckEmail = await apiDataService
						.checkEmailForAuth({ email: user.email })
						.catch((error) => {
							setMessage(
								"error",
								error.response?.status === 404
									? "Email not found!"
									: error.response?.data?.message || "Error checking email!",
							);
							return null;
						});
					if (!responseCheckEmail) {
						isSubmitting.value = false;
						return;
					}
					try {
						const response = await apiDataService.requestOTP({
							email: user.email,
							user_type: user.user_type,
						});
						if (response.code === 201) {
							savedEmail.value = user.email;
							isOTPRequested.value = true;
							user.email = "";
							startCountdown();
						}
					} catch {
						setMessage("error", "Error During OTP Request");
					} finally {
						isResending.value = isSubmitting.value = false;
					}
				} else {
					isSubmitting.value = isResending.value = true;
					try {
						const response = await apiDataService.verifyOTP({
							email: savedEmail.value,
							otp: user.otp,
							user_type: user.user_type,
						});
						if (response.code === 200) router.push(redirectUrl.value);
						else setMessage("error", "OTP verification failed!");
					} catch {
						setMessage("error", "Error verifying OTP!");
					} finally {
						isSubmitting.value = isResending.value = false;
					}
				}
			}
		};

		const resendOTP = async () => {
			if (!canResend.value) return;
			isResending.value = true;
			resendAttempts.value += 1;
			try {
				if (resendAttempts.value >= maxResendAttempts) return;
				const response = await apiDataService.requestOTP({
					email: savedEmail.value,
					user_type: user.user_type,
				});
				if (response.code === 201) {
					setMessage("success", "OTP resent successfully!");
					startCountdown();
				}
			} catch {
				setMessage("error", "Error resending OTP!");
			} finally {
				isResending.value = false;
			}
		};

		// ── carousel ─────────────────────────────────────────────────
		const currentSlide = ref(0);
		let carouselTimer = null;

		const goSlide = (n) => {
			currentSlide.value = n;
			clearInterval(carouselTimer);
			carouselTimer = setInterval(
				() => goSlide((currentSlide.value + 1) % 3),
				3500,
			);
		};

		// Static data for right panel visuals
		const slideOneStats = [
			{ num: "8", lbl: "Events", sm: false },
			{ num: "200+", lbl: "Tickets", sm: false },
			{ num: "100%", lbl: "QR Rate", sm: true },
		];
		const mockEvents = [
			{
				name: "Sound without Borders",
				date: "June 1 · 6:00 PM",
				label: "Ended",
			},
			{ name: "Poetry Night", date: "May 1 · 7:30 PM", label: "Ended" },
			{ name: "Cultural Aperitivo", date: "Feb 23 · 6:00 PM", label: "Open" },
		];
		const chartBars = [
			{ h: "40%", hi: false },
			{ h: "55%", hi: false },
			{ h: "35%", hi: false },
			{ h: "70%", hi: false },
			{ h: "50%", hi: false },
			{ h: "90%", hi: true },
			{ h: "65%", hi: false },
		];

		onMounted(() => {
			if (route.query.redirect)
				redirectUrl.value = decodeURIComponent(route.query.redirect);
			carouselTimer = setInterval(
				() => goSlide((currentSlide.value + 1) % 3),
				3500,
			);
		});

		onBeforeUnmount(() => clearInterval(carouselTimer));

		return {
			user,
			submitForm,
			isOTPRequested,
			isRegistering,
			successMessage,
			errorMessage,
			infoMessage,
			warningMessage,
			setMessage,
			isSubmitting,
			isResending,
			countdown,
			resendOTP,
			resendAttempts,
			maxResendAttempts,
			canResend,
			currentSlide,
			goSlide,
			slideOneStats,
			mockEvents,
			chartBars,
		};
	},
};
</script>
